module.exports = __webpack_public_path__ + "img/demo2.11b153a1.jpg";